// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid p {
  color: var(--ion-color-light);
  font-weight: bold;
  text-transform: inherit;
  font-size: 1rem;
  text-align: center;
}
ion-grid ion-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 11px;
  margin: 0;
}
@media screen and (max-width: 768px) {
  ion-grid ion-row {
    gap: 6px;
  }
}
ion-grid ion-col {
  padding: 0;
  margin: 0;
  flex: none !important;
  max-width: none !important;
  width: auto !important;
}
ion-grid ion-col.cursor-pointer {
  display: block;
}
ion-grid img {
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  display: block;
}

.gallery-images .row:nth-child(2) {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 11px;
  padding: 4px;
  margin: 0;
  overflow: visible;
}
.gallery-images .row:nth-child(2) .col {
  padding: 0;
  margin: 0;
  min-width: auto;
  max-width: none;
}
.gallery-images img {
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  min-width: auto;
}

.ios.platform-cordova my-games ion-grid {
  padding-bottom: 0;
}
.ios.platform-cordova my-games ion-grid h2 {
  font-weight: bold;
  padding-left: 12px;
}
.ios.platform-cordova my-games ion-grid img {
  height: 73px;
  min-width: 73px;
  width: 73px;
}
@media screen and (orientation: landscape) {
  .ios.platform-cordova my-games ion-grid img {
    height: 50px;
    width: 50px;
  }
}
.ios.platform-cordova my-games ion-grid p {
  font-size: 12px;
  font-weight: normal;
  margin-top: 8px;
  margin-right: 26px;
  margin-bottom: 0;
  padding-left: 0;
  text-align: center;
  text-transform: none;
}
.ios.platform-cordova my-games ion-grid p.heading {
  font-size: 2.4rem;
  margin-bottom: 11px;
  padding-left: 12px;
  text-align: left;
  text-transform: initial;
}
@media screen and (orientation: landscape) {
  .ios.platform-cordova my-games ion-grid p.heading {
    font-size: 2rem;
    margin-bottom: 5px;
    margin: 0 !important;
  }
}
.ios.platform-cordova my-games ion-grid .row:nth-child(2) .col {
  margin-left: 0;
  padding-bottom: 0;
}
.ios.platform-cordova my-games ion-grid .row:nth-child(2) .col:first-of-type {
  margin-left: 12px;
}
.ios.platform-cordova my-games ion-grid .row:nth-child(2)::-webkit-scrollbar {
  display: none;
}
.ios.platform-cordova my-games .gallery-images {
  padding-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/last-played-games/last-played-games.component.scss"],"names":[],"mappings":"AACI;EACI,6BAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAAR;AAGI;EACI,aAAA;EACA,qCAAA;EACA,SAAA;EACA,SAAA;AADR;AAII;EACI;IACI,QAAA;EAFV;AACF;AAKI;EACI,UAAA;EACA,SAAA;EACA,qBAAA;EACA,0BAAA;EACA,sBAAA;AAHR;AAKQ;EACI,cAAA;AAHZ;AAOI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALR;;AAUI;EACI,aAAA;EACA,qCAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;AAPR;AASQ;EACI,UAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAPZ;AAWI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AATR;;AAgBQ;EACI,iBAAA;AAbZ;AAeY;EACI,iBAAA;EACA,kBAAA;AAbhB;AAgBY;EACI,YAAA;EACA,eAAA;EACA,WAAA;AAdhB;AAgBgB;EALJ;IAMQ,YAAA;IACA,WAAA;EAblB;AACF;AAgBY;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;AAdhB;AAgBgB;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAdpB;AAgBoB;EAPJ;IAQQ,eAAA;IACA,kBAAA;IACA,oBAAA;EAbtB;AACF;AAkBgB;EACI,cAAA;EAEA,iBAAA;AAjBpB;AAmBoB;EACI,iBAAA;AAjBxB;AAsBY;EACI,aAAA;AApBhB;AAwBQ;EACI,mBAAA;AAtBZ","sourcesContent":["ion-grid {\n    p {\n        color: var(--ion-color-light);\n        font-weight: bold;\n        text-transform: inherit;\n        font-size: 1rem;\n        text-align: center;\n    }\n\n    ion-row {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 11px;\n        margin: 0;\n    }\n\n    @media screen and (max-width: 768px) {\n        ion-row {\n            gap: 6px;\n        }\n    }\n\n    ion-col {\n        padding: 0;\n        margin: 0;\n        flex: none !important;\n        max-width: none !important;\n        width: auto !important;\n\n        &.cursor-pointer {\n            display: block;\n        }\n    }\n\n    img {\n        width: 100%;\n        height: auto;\n        aspect-ratio: 1;\n        object-fit: cover;\n        display: block;\n    }\n}\n\n.gallery-images {\n    .row:nth-child(2) {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 11px;\n        padding: 4px;\n        margin: 0;\n        overflow: visible;\n\n        .col {\n            padding: 0;\n            margin: 0;\n            min-width: auto;\n            max-width: none;\n        }\n    }\n\n    img {\n        width: 100%;\n        height: auto;\n        aspect-ratio: 1;\n        object-fit: cover;\n        min-width: auto;\n    }\n}\n\n\n.ios.platform-cordova {\n    my-games {\n        ion-grid {\n            padding-bottom: 0;\n\n            h2 {\n                font-weight: bold;\n                padding-left: 12px;\n            }\n\n            img {\n                height: 73px;\n                min-width: 73px;\n                width: 73px;\n\n                @media screen and (orientation:landscape) {\n                    height: 50px;\n                    width: 50px;\n                }\n            }\n\n            p {\n                font-size: 12px;\n                font-weight: normal;\n                margin-top: 8px;\n                margin-right: 26px;\n                margin-bottom: 0;\n                padding-left: 0;\n                text-align: center;\n                text-transform: none;\n\n                &.heading {\n                    font-size: 2.4rem;\n                    margin-bottom: 11px;\n                    padding-left: 12px;\n                    text-align: left;\n                    text-transform: initial;\n\n                    @media screen and (orientation:landscape) {\n                        font-size: 2rem;\n                        margin-bottom: 5px;\n                        margin: 0 !important;\n                    }\n                }\n            }\n\n            .row:nth-child(2) {\n                .col {\n                    margin-left: 0;\n                    //   margin-right: 30px;\n                    padding-bottom: 0;\n\n                    &:first-of-type {\n                        margin-left: 12px;\n                    }\n                }\n            }\n\n            .row:nth-child(2)::-webkit-scrollbar {\n                display: none;\n            }\n        }\n\n        .gallery-images {\n            padding-bottom: 5px;\n            //   background: #000;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
